<template>
  <div id="sidebar-category" class="sidebar-category">
    <div class="col-md-3">
      <div class="">
        <p style="margin-bottom: 0">
          <a href="#/" class="btn_side" style="margin-bottom: 0">Categories</a>
        </p>
        <div class="box_style_1">
          <ul id="cat_nav">
            <li v-for="cats in getAllCategory" :key="cats.id">
              <a
                href="javascript:void(0)"
                @click.prevent="getMenu(cats.id, cats.slug)"
                :id="cats.slug + '-' + cats.id"
                class="side_menu"
              >
                {{ cats.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="box_style_2 hidden-xs" style="padding: 3px">
        <router-link to="/special">
          <img
            src="/img/special.jpg"
            class="img-responsive"
            style="cursor: pointer"
          />
        </router-link>
      </div>
      <div class="box_style_2 hidden-xs text-left" id="help">
        <div>
          <strong class="ms-slab-font">
            <span class="fa fa-map-marker"></span>
            LOCATION
          </strong>
          <br />
          <p
            v-html="this.settings.length > 0 ? this.settings[3].meta_value : ''"
          ></p>
        </div>
        <hr style="margin-bottom: 10px; margin-top: 10px" />
        <div>
          <strong class="ms-slab-font">
            <span class="fa fa-clock-o"></span>
            DELIVERY AREAS
          </strong>
          <br />
          <p
            v-html="this.settings.length > 0 ? this.settings[4].meta_value : ''"
          ></p>
        </div>
        <hr style="margin-bottom: 10px; margin-top: 10px" />
        <div>
          <strong class="ms-slab-font">
            <span class="fa fa-clock-o"></span>
            OPENING
          </strong>
          <br />
          <p
            v-html="this.settings.length > 0 ? this.settings[5].meta_value : ''"
          ></p>
        </div>
        <hr style="margin-bottom: 10px; margin-top: 10px" />
        <div>
          <strong class="ms-slab-font">
            <span class="fa fa-warning text-danger"></span>
            <router-link to="/about-us" style="color: #000">
              {{ this.settings.length > 0 ? this.settings[7].meta_key : "" }}
            </router-link>
          </strong>
          <br />
          <p
            v-html="this.settings.length > 0 ? this.settings[7].meta_value : ''"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as render from "../utils/render";
export default {
  name: "SideCategory",
  created() {
    if (this.$route.params) {
      let event = this.$route.params.id;
      $("#" + slug + "-" + event).css({ background: "#f90" });
      let slug = this.$route.params.slug;
      if (event === undefined && slug === undefined) {
        slug = "traditional-pizza";
        event = 1;
      }
      this.getMenu(event, slug);

      $("a.side_menu").removeClass("active");
      $("#" + slug + "-" + event).addClass("active");
    }
    this.$store.dispatch("getAllCategory");
    this.$store.dispatch("getOnlineOrderingStatus");
  },
  computed: {
    ...mapGetters(["getAllCategory", "settings"]),
  },
  methods: {
    getMenu(event, slug) {
      console.log(event);
      console.log(slug);

      this.$store.dispatch("getMenu", event);
      this.$router.push("category/" + slug + "/" + event).catch((err) => {
        console.log(err.message);
      });
      $("a.side_menu").removeClass("active");
      $("#" + slug + "-" + event).addClass("active");
      $(".topping_class").css({ display: "none" });
      $(".collapsed_open").css({ display: "inline-block" });
      $(".collapsed_close").css({ display: "none" });
    },
  },
  updated() {
    let event = this.$route.params.id;
    let slug = this.$route.params.slug;
    $("a.side_menu").removeClass("active");
    $("#" + slug + "-" + event).addClass("active");
  },
};
</script>
